import {API_VERSION} from '@/utils/constants/commonConstants';
import {HTTP_METHODS} from '@/utils/constants/httpMethods';
import {buildQueryParams} from '@/utils/commons';

export const REWARD_CATALOG_CONFIG = {
  REWARD_CATALOG: (queryParams) => ({
    endPoint: `rewards/list?${buildQueryParams(queryParams)}`,
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
    // mockData: RewardCatalogListMockData,
  }),

  REWARD_CATALOG_CSV_DOWNLOAD: (queryParams) => {
    const query = queryParams ? `?${buildQueryParams(queryParams)}` : '';
    return {
      endPoint: `rewards/download${query}`,
      method: HTTP_METHODS.POST
    };
  },
  REWARD_CATALOG_TEMPLATE_DOWNLOAD: () => ({
    endPoint: `template/reward-catalog`,
    method: HTTP_METHODS.GET
  }),
  REWARD_DIGITAL_CODES_TEMPLATE_DOWNLOAD: () => ({
    endPoint: `rewards/digital-codes/download`,
    method: HTTP_METHODS.POST
  }),
  REWARD_CATALOG_BULK_UPLOAD: () => ({
    endPoint: `rewards/bulk-upload`,
    method: HTTP_METHODS.POST
  }),
  DIGITAL_CODES_REPORT: () => ({
    endPoint: `rewards/digital-codes/report`,
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  })
};
